<div *ngIf="dliLinePriceVisible" [attr.data-testid]="'line-sum-input-readonly-mode'">
    <div class="p-inputgroup">
        <app-phx-input-number
            #inputNumber
            (displayValueChange)="onModelChange($event)"
            [inputStyleClass]="{
                width: '100%'
            }"
            [displayValue]="ngModel()"
            mode="decimal"
            [disabled]="isInputDisabled"
            [minFractionDigits]="decimalPlaces"
            [inputStyleClass]="'!rounded-e-none'"
            [upDownButtons]="false"
            [attr.data-testid]="'line-sum-input-number'"
        ></app-phx-input-number>
        <p-button
            styleClass="me-1"
            (onClick)="enableEditDiscountedLinePrice()"
            [pTooltip]="'document-line-item.activate-backwards-calculation-input' | translate"
            outlined="true"
            [attr.data-testid]="'enable-edit-line-price-btn'"
        >
            <i class="fa-solid fa-pen fa-sm"></i>
        </p-button>
    </div>
</div>

<div *ngIf="!dliLinePriceVisible" [attr.data-testid]="'line-sum-input-edit-mode'">
    <p-inputgroup>
        <app-phx-input-number
            #inputEdit
            pAutoFocus
            [(ngModel)]="editPrice"
            [ngModelOptions]="{standalone: true}"
            mode="decimal"
            [autofocus]="true"
            [minFractionDigits]="decimalPlaces"
            [inputStyleClass]="'!rounded-e-none'"
            [attr.data-testid]="'line-sum-input-edit-number'"
        ></app-phx-input-number>
        <p-button
            (onClick)="saveEditedDiscountedLinePrice()"
            severity="primary"
            [pTooltip]="'document-line-item.calculate-item-price-backwards' | translate"
            styleClass="me-1"
            [attr.data-testid]="'save-edited-line-price-btn'"
        >
            <i class="fa-solid fa-check fa-sm"></i>
        </p-button>
    </p-inputgroup>
</div>
